import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Button, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from '@material-ui/icons/Edit';
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar
} from "../../../../_metronic/_partials/controls";
import { changeStatusAdvisorService, deleteAdvisorService, getAllAdvisorServices } from "../../../../api/advisorService";
import { getNonEmpty } from '../../../../utils/helpers';
import { alertError, alertSuccess } from '../../../../utils/logger';
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import Table, {
    buttonsStyle,
    dateFormatter,
    substringFormatter
} from "../../../components/tables/table";

function getData(advisorServices) {
    return advisorServices.map(advisorService => ({
        title: getNonEmpty(advisorService.title),
        description: getNonEmpty(advisorService.description),
        createdAt: advisorService.createdAt,
        active: advisorService.active,
        id: advisorService._id,
    }));
}

export default function AdvisorServicePage() {
    const history = useHistory();
    const user = useSelector((store) => store.authentication?.user, shallowEqual);

    const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
    const [refresh, setRefresh] = useState(false)
    const [data, setData] = useState([])
    const [advisorService, setAdvisorService] = useState(null);

    useEffect(() => {
        getAllAdvisorServices()
            .then((res) => {
                setData(getData(res.data));
                setRefresh(false);
            })
            .catch(error => {
                alertError({ error: error, customMessage: 'Could not get advisor services.' })
            })
    }, [refresh]);

    function buttonFormatter(cell) {
        const elem = data.find((item) => item.id === cell);
        return (
            <>
                <Tooltip title="Edit">
                    <Button
                        style={buttonsStyle} size="small"
                        onClick={() => history.push('/edit-advisorService/' + elem.id)}>
                        <EditIcon />
                    </Button>
                </Tooltip>
                {user?.role === "admin" && (
                    <>
                        <Tooltip title={elem?.active ? "Deactivate" : "Activate"}>
                            <Button
                                style={buttonsStyle}
                                size="small"
                                onClick={() => {
                                    setAdvisorService(elem);
                                    setOpenConfirmDialog(1);
                                }}
                            >
                                {elem?.active ? (
                                    <ToggleOffIcon />
                                ) : (
                                    <ToggleOnIcon style={{ color: "red" }} />
                                )}
                            </Button>
                        </Tooltip>
                        <Tooltip title="Delete">
                            <Button
                                style={buttonsStyle}
                                size="small"
                                onClick={() => {
                                    setAdvisorService(elem);
                                    setOpenConfirmDialog(2);
                                }}
                            >
                                <DeleteIcon />
                            </Button>
                        </Tooltip>
                    </>
                )}
            </>
        );
    }


    const columns = [
        { dataField: "title", text: "Title", sort: true },
        { dataField: "description", text: "Description", sort: true, formatter: substringFormatter },
        {
            dataField: "createdAt",
            text: "Created at",
            formatter: dateFormatter,
            sort: true,
        },
        { dataField: "id", text: "", formatter: buttonFormatter }
    ];

    return (
        <Card>
            <CardHeader title="Advisors services list">
                <CardHeaderToolbar>
                    <button
                        type="button"
                        className="btn btn-primary text-white"
                        onClick={() => history.push("/edit-advisorService")}
                    >
                        Add new
                    </button>
                </CardHeaderToolbar>
            </CardHeader>
            <CardBody>
                <Table data={data} columns={columns} key={data.length} />

                <ConfirmDialog
                    title={`Are you sure you want to ${advisorService?.active ? "deactivate" : "activate"} this advisor service?`}
                    open={openConfirmDialog === 1}
                    setOpen={setOpenConfirmDialog}
                    onConfirm={() => {
                        changeStatusAdvisorService(advisorService.id, !advisorService?.active)
                            .then((res) => {
                                alertSuccess({
                                    title: `${advisorService?.active ? "Deactivate!" : "Activate!"
                                        }`,
                                    customMessage: `Advisor Service ${advisorService?.active ? "deactivate" : "activate"
                                        } successfully`,
                                });
                                setRefresh(true);
                            })
                            .catch((error) => {
                                alertError({
                                    error: error,
                                    customMessage: `Could not ${advisorService?.active ? "deactivate" : "activate"
                                        } the advisor service.`,
                                });
                            });
                    }}
                />
                <ConfirmDialog
                    title={"Are you sure you want to delete this advisor service?"}
                    open={openConfirmDialog === 2}
                    setOpen={setOpenConfirmDialog}
                    onConfirm={() => {
                        deleteAdvisorService(advisorService.id)
                            .then((res) => {
                                alertSuccess({
                                    title: "Deleted!",
                                    customMessage: "Technology deleted successfully.",
                                });
                                setRefresh(true);
                            })
                            .catch((error) => {
                                alertError({
                                    error: error,
                                    customMessage: "Could not delete the advisor service.",
                                });
                            });
                    }}
                />
            </CardBody>
        </Card>
    );
}